import { headers } from "./headers";
import { headersSelo } from "./headersSelo";
import { headersParceiro } from "./headersParceiro";

import { filtros } from "./filtros";
import { categorias } from "./categorias";
import { atualUfDefinition } from "@/helpers/utils"


function getTitle() {
    if (atualUfDefinition.isParceiro) {
        return {
            5: "Situação das visitas por parceiro",
            6: "Situação das tarefas por parceiro",
            7: "Diagnósticos Pendentes por eixo e parceiro",
            9: "O que falta evidenciar por parceiro e eixo",
            17: "Quantidade de Mensurações realizadas por regional e parceiro",
            21: "Consolidado de indicadores respondidos SIM por eixo, parceiro e Unidade Regional",
            22: "Analítico de indicadores com respectivas respostas dos parceiro e regiões selecionadas",
            23: "Plano de ação analítico - atualizado por parceiro, eixo e região",
            24: "Eixos por parceiro",
            25: "Eixos por parceiro - desagrupado",
            27: "Evidências rejeitadas por parceiro"
        }
    }
    if (atualUfDefinition.isSala) {
        return {
            5: "Situação das visitas por sala",
            6: "Situação das tarefas por sala",
            7: "Diagnósticos Pendentes por eixo e sala",
            9: "O que falta evidenciar por sala e eixo",
            17: "Quantidade de Mensurações realizadas por regional e sala",
            21: "Consolidado de indicadores respondidos SIM por eixo, sala e Unidade Regional",
            22: "Analítico de indicadores com respectivas respostas dos sala e regiões selecionadas",
            23: "Plano de ação analítico - atualizado por sala, eixo e região",
            24: "Eixos por sala",
            25: "Eixos por sala - desagrupado",
            27: "Evidências rejeitadas por sala",
        }
    }

    return {}


}

export const relatorios = [
    {
        title: getTitle()[1] || "Execução por Tarefas",
        rotaApi: "get-execucao-por-tarefas",
        header: headers.execucao_por_tarefas,
        category: categorias.execucao,
        id: 1,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[2] || "Execução por horas",
        rotaApi: "get-execucao",
        header: headers.execucao,
        category: categorias.execucao,
        id: 2,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[3] || "Relatórios por Solução",
        rotaApi: "get-relatorios-por-solucao",
        header: headers.relatorio_por_solucao,
        category: categorias.execucao,
        id: 3,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[4] || "Encontros por Solução",
        rotaApi: "get-encontros-por-solucao",
        header: headers.encontros_por_solucao,
        category: categorias.execucao,
        id: 4,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[5] || "Situação das visitas por município",
        rotaApi: "get-situacao-visitas",
        header: headers.situacaoVisitas,
        category: categorias.indicador,
        id: 5,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[6] || "Situação das tarefas por município",
        rotaApi: "get-situacao-tarefas",
        header: headers.situacaoTarefa,
        category: categorias.indicador,
        id: 6,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[7] || "Diagnósticos Pendentes por eixo e município",
        rotaApi: "get-municipios-sem-diagnostico",
        header: headers.diagnostico,
        category: categorias.indicador,
        id: 7,
        filters: [filtros.statusRelacionamento],
    },
    {
        title: getTitle()[8] || "Diagnósticos Finalizados",
        rotaApi: "get-diagnosticos-finalizados",
        header: headers.diagnosticoFinalizado,
        category: categorias.indicador,
        id: 8,
        filters: [filtros.statusRelacionamento],
    },

    {
        title: getTitle()[9] || "O que falta evidenciar por município e eixo",
        rotaApi: "get-falta-evidenciar",
        header: headers.evidencias,
        headerSelo: headersSelo.evidencias,
        category: categorias.indicador,
        id: 9,
        filters: [filtros.statusRelacionamento, filtros.regional],
    },
    {
        title: getTitle()[10] || "Situação das evidências enviadas",
        rotaApi: "get-aprovacao-rejeicao",
        header: headers.rejeicao,
        headerSelo: headersSelo.rejeicao,
        category: categorias.indicador,
        id: 10,
        filters: [filtros.statusRelacionamento, filtros.regional],
    },
    // {
    //     title: getTitle()[11] || "Execução das horas",
    //     rotaApi: "get-execucao-por-horas",
    //     header: headers.execucao_hora,
    //     category: categorias.execucao,
    //     id: 11,
    //     filters: [
    //         filtros.municipio,
    //         filtros.responsavel,
    //         filtros.solucao,
    //         filtros.grupoSolucao,
    //         filtros.grupoUsuario,
    //         filtros.statusRelacionamento,
    //         filtros.dataInicial,
    //         filtros.dataFim,
    //     ],
    // },
    {
        title: getTitle()[12] || "Situação das medalhas",
        rotaApi: "get-execucao-por-situacao-medalha",
        header: headers.situacao_medalha,
        category: categorias.indicador,
        id: 12,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[13] || "Situação geral de pontos e medalhas",
        rotaApi: "get-execucao-por-situacao-pontos-medalha-por-tema",
        header: headers.situacao_medalha_pontos_tema,
        category: categorias.indicador,
        id: 13,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[14] || "Radar",
        rotaApi: "",
        component: "Radar",
        isFullAdmin: true,
        id: 14,
        category: categorias.execucao,

    },
    {
        title: getTitle()[15] || "Execução por tarefas com data de início e fim",
        rotaApi: "get-execucao-por-tarefas-inicio-fim",
        header: headers.execucao_tarefas_inicio_fim,
        category: categorias.execucao,
        id: 15,
        filters: [
            filtros.municipio,
            filtros.responsavel,
            filtros.solucao,
            filtros.grupoSolucao,
            filtros.grupoUsuario,
            filtros.statusRelacionamento,
            filtros.dataInicial,
            filtros.dataFim,
        ],
    },
    {
        title: getTitle()[16] || "Município e eixos por Status do Relacionamento",
        rotaApi: "get-status-relacionamento",
        header: headers.municipio_eixo_status_relacionamento,
        category: categorias.indicador,
        id: 16,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.status,
            filtros.eixo,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[17] || "Quantidade de Mensurações realizadas por regional e município",
        rotaApi: "get-mensuracao",
        header: headers.municipio_quantidade_mensuracoes_regional_municipio,
        category: categorias.indicador,
        id: 17,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.status,
            filtros.eixo,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[18] || "Municípios por região e eixos com a quantidade de mensurações",
        rotaApi: "get-municipio-regiao",
        header: headers.municipio_quantidade_mensuracoes,
        category: categorias.indicador,
        id: 18,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.status,
            filtros.eixo,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[19] || "Alerta para T0 pendente",
        rotaApi: "get-alerta-to",
        header: headers.to_pendentes,
        category: categorias.indicador,
        id: 19,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.status,
            filtros.tema,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[20] || "Lista de indicadores ativos",
        rotaApi: "get-indicadores-ativos",
        header: headers.indicadores_ativos,
        headerSelo: headersSelo.indicadores_ativos,
        category: categorias.indicador,
        id: 20,
        filters: [
            filtros.eixo,
        ],
    },
    {
        title: getTitle()[21] || "Consolidado de indicadores respondidos SIM por eixo, município e Unidade Regional",
        rotaApi: "get-indicadores-consolidado",
        header: headers.consolidado_indicadores_sim,
        category: categorias.indicador,
        id: 21,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.eixo,
        ],
    },
    {
        title: getTitle()[22] || "Analítico de indicadores com respectivas respostas dos municípios e regiões selecionadas",
        rotaApi: "get-indicadores-analiticos",
        header: headers.analitico_indicadores,
        category: categorias.indicador,
        id: 22,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.eixo,
        ],
    },
    {
        title: getTitle()[23] || "Plano de ação analítico - atualizado por município, eixo e região",
        rotaApi: "get-plano-acao",
        header: headers.plano_acao_analitico,
        category: categorias.indicador,
        id: 23,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.eixo,
        ],
    },

    {
        title: getTitle()[24] || "Eixos por municipio",
        rotaApi: "get-eixos-por-municipios",
        header: headers.eixo_municipio,
        category: categorias.indicador,
        id: 24,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.statusRelacionamento,
        ],
    },

    {
        title: getTitle()[25] || "Eixos por municipio - desagrupado",
        rotaApi: "get-eixos-por-municipios-desagrupado",
        header: headers.eixo_municipio_desagrupado,
        category: categorias.indicador,
        id: 25,
        filters: [
            filtros.uf,
            filtros.regional,
            filtros.statusRelacionamento,
        ],
    },
    {
        title: getTitle()[26] || "Relação de diagnósticos e acompanhamentos realizados com Usuário e Evolução",
        rotaApi: "get-relacao-diagnosticos-acompanhamentos-realizados-usuario-evolucao",
        header: headers.relacao_diagnosticos,
        category: categorias.indicador,
        id: 26,
        filters: [
            filtros.municipio,
            filtros.regional,
            filtros.usuario
        ],
    },
    {
        title: getTitle()[27] || "Evidências rejeitadas por municipio",
        rotaApi: "get-evidencia-rejeitada-por-municipio",
        header: headers.evidencia_rejeitada_por_municipio,
        category: categorias.indicador,
        id: 27,
        defaultFilters: {
            municipioId: [0]
        },
        filters: [filtros.municipio],
    },
    {
        title: getTitle()[28] || "Parceiros com respectivos selos atribuídos",
        rotaApi: "get-parceiros-selos-atribuidos",
        header: headers.parceiro_selos_atribuidos,
        category: categorias.indicador,
        id: 28,
        exibirEm: ['isSala'],
        defaultFilters: {
            municipioId: [0]
        },
        filters: [filtros.regional],
    },
    {
        title: getTitle()[29] || "Quantitativo de selos atribuídos",
        rotaApi: "quantidade-selos-atribuidos",
        header: headers.quantidade_selos_atribuidos,
        category: categorias.indicador,
        id: 29,
        defaultFilters: {
            municipioId: [0]
        },
        exibirEm: ['isSala'],
        filters: [],
    },
    {
        title: getTitle()[30] || "Diagnósticos consolidados por situação",
        rotaApi: "diagnosticos-consolidados-por-situacao",
        header: headers.diagnosticos_consolidados_situacao,
        category: categorias.indicador,
        id: 30,
        exibirEm: ['isSala'],
    },
    {
        title: getTitle()[31] || "Diagnósticos detalhados",
        rotaApi: "diagnosticos-detalhados",
        headerParceiro: headersParceiro.diagnosticos_detalhados,
        header: headers.diagnosticos_detalhados,
        category: categorias.indicador,
        id: 31,
        exibirEm: ['isSala'],
    },
    {
        title: getTitle()[32] || "Relatórios Administrativos por período",
        rotaApi: "get-relatorio-por-periodo",
        header: headers.diagnosticos_admin_periodo,
        category: categorias.execucao,
        id: 32,
        filters: [filtros.usuario, filtros.municipio, filtros.dataInicial, filtros.dataFim],
    },
    {
        title: getTitle()[33] || "Situação detalhada do envio de evidências",
        rotaApi: "get-situacao-detalhada-envio-evidencia",
        header: headers.situacao_detalhada_envio_evidencia,
        headerParceiro: headersParceiro.situacao_detalhada_envio_evidencia,
        category: categorias.indicador,
        id: 33,
        exibirEm: ['isSala'],
        filters: [filtros.municipio, filtros.regional],
    },

];
